/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/label-has-associated-control */
import {
    Box,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
    useMediaQuery
} from '@mui/material';
import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';

const LabelledField = ({ label, children }) => (
    <Box mb={1}>
        <Typography fontSize="0.85rem" fontWeight="bold" mb={0.5}>
            {label}
        </Typography>
        {children}
    </Box>
);

const CustomTextField = (props) => (
    <TextField
        variant="outlined"
        fullWidth
        size="small"
        InputProps={{
            style: {
                border: '1px solid black',
                borderRadius: 0,
                padding: 0,
                fontSize: '0.85rem'
            }
        }}
        sx={{
            bgcolor: '#fff',
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    border: '1px solid black',
                    borderRadius: 0
                },
                '&:hover fieldset': {
                    border: '1px solid black'
                },
                '&.Mui-focused fieldset': {
                    border: '1px solid black'
                }
            }
        }}
        {...props}
    />
);

const AdmissionCard = () => {
    const isMobile = useMediaQuery('(max-width:600px)');
    const location = useLocation();
    const studentData = location.state?.studentData;
    const { token } = useParams();

    useEffect(() => {
        localStorage.setItem('webViewToken', token);
    }, [token]);
    const PhotoBlock = () => (
        <Box
            sx={{
                width: '100%',
                height: isMobile ? 'auto' : '100%',
                minHeight: 170,
                border: '1px solid',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                mb: isMobile ? 2 : 0
            }}
        >
            {studentData?.studentPhoto ? (
                <img
                    src={studentData?.studentPhoto}
                    alt="Student"
                    style={{
                        width: '100%',
                        height: '100%',
                        border: '1px solid #ccc',
                        borderRadius: 4
                    }}
                />
            ) : (
                <Typography fontSize="0.85rem" textAlign="center" fontWeight="bold">
                    Affix latest <br /> passport size <br /> photograph
                </Typography>
            )}
        </Box>
    );
    return (
        <div
            style={{
                fontFamily: 'Arial, sans-serif',
                maxWidth: '800px',
                margin: '0 auto',
                padding: '20px',
                backgroundColor: '#f5f0e1',
                borderRadius: '8px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
            }}
        >
            <Box sx={{ backgroundColor: '#f5f0e1', p: 2 }}>
                <Box
                    component="img"
                    src="/UniversityHeader.png"
                    alt="University Header"
                    sx={{ maxWidth: '100%', height: 'auto', display: 'block', mb: 2 }}
                />
                <Box
                    sx={{
                        backgroundColor: '#333',
                        color: 'white',
                        padding: '5px 10px',
                        textAlign: 'center',
                        fontWeight: 'bold',
                        fontSize: '16px',
                        margin: 'auto',
                        width: isMobile ? '100%' : '40%',
                        mb: 2
                    }}
                >
                    ADMISSION CARD
                </Box>
                <Grid container spacing={2}>
                    <Grid item xs={12} display={isMobile ? 'block' : 'flex'} textAlign="center" justifyContent="flex-end">
                        <Typography variant="h5" fontWeight={600}>
                            Session: {studentData?.courseDetail?.academicYear?.session?.tag || '—'}
                        </Typography>
                    </Grid>

                    {isMobile && (
                        <Grid item xs={12}>
                            <PhotoBlock />
                        </Grid>
                    )}
                    <Grid item xs={isMobile ? 12 : 9}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <LabelledField label="Roll No.">
                                    <CustomTextField value={studentData?.rollNo} />
                                </LabelledField>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <LabelledField label="Enrollment Number">
                                    <CustomTextField value={studentData?.enrollmentNo} />
                                </LabelledField>
                            </Grid>
                            <Grid item xs={12}>
                                <LabelledField label="Student's Name (in block letters)">
                                    <CustomTextField value={studentData?.studentName?.toUpperCase()} />
                                </LabelledField>
                            </Grid>
                        </Grid>
                    </Grid>
                    {!isMobile && (
                        <Grid item xs={3}>
                            <PhotoBlock />
                        </Grid>
                    )}
                </Grid>
                <Grid container spacing={2} mt={isMobile ? 0 : 2}>
                    <Grid item xs={12} md={4.5}>
                        <LabelledField label="Date of Birth">
                            <CustomTextField type="date" value={studentData?.personalDetails?.dob} />
                        </LabelledField>
                    </Grid>

                    <Grid item xs={12} md={2.5}>
                        <LabelledField label="Blood Group">
                            <CustomTextField value={studentData?.personalDetails?.bloodGroup} />
                        </LabelledField>
                    </Grid>

                    <Grid item xs={12} md={2.5}>
                        <LabelledField label="Religion">
                            <CustomTextField value={studentData?.personalDetails?.religion} />
                        </LabelledField>
                    </Grid>

                    <Grid item xs={12} md={2.5}>
                        <LabelledField label="Caste">
                            <CustomTextField value={studentData?.personalDetails?.caste} />
                        </LabelledField>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <LabelledField label="E-mail ID">
                            <CustomTextField value={studentData?.personalDetails?.email} />
                        </LabelledField>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <LabelledField label="ID Mark">
                            <CustomTextField value={studentData?.personalDetails?.idMark} />
                        </LabelledField>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <LabelledField label="Contact No">
                            <CustomTextField value={studentData?.personalDetails?.phone} />
                        </LabelledField>
                    </Grid>
                </Grid>
            </Box>
            <Box mb={3}>
                <TableContainer component={Paper} variant="outlined">
                    <Table size="small" aria-label="Examinations Table">
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#f0f0f0' }}>
                                {['Name of Exam', 'Board/University', 'Passed Year', 'Percentage'].map((label) => (
                                    <TableCell
                                        key={label}
                                        align="center"
                                        sx={{
                                            border: '1px solid #333',
                                            fontWeight: 'bold',
                                            fontSize: '16px',
                                            padding: '10px'
                                        }}
                                    >
                                        {label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {studentData?.educationDetails?.map((exam, index) => (
                                <TableRow key={index}>
                                    <TableCell sx={{ border: '1px solid #333', padding: '8px' }}>
                                        <CustomTextField
                                            value={exam?.qualificationType?.name}
                                            variant="standard"
                                            fullWidth
                                            InputProps={{ disableUnderline: true }}
                                            sx={{ fontSize: '14px' }}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ border: '1px solid #333', padding: '8px' }}>
                                        <CustomTextField
                                            value={exam?.board}
                                            variant="standard"
                                            fullWidth
                                            InputProps={{ disableUnderline: true }}
                                            sx={{ fontSize: '14px' }}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ border: '1px solid #333', padding: '8px' }}>
                                        <CustomTextField
                                            value={exam?.passedYear}
                                            variant="standard"
                                            fullWidth
                                            InputProps={{ disableUnderline: true }}
                                            sx={{ fontSize: '14px' }}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ border: '1px solid #333', padding: '8px' }}>
                                        <CustomTextField
                                            value={exam?.percentage}
                                            variant="standard"
                                            fullWidth
                                            InputProps={{ disableUnderline: true }}
                                            sx={{ fontSize: '14px' }}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}

                            <TableRow>
                                <TableCell
                                    colSpan={3}
                                    align="right"
                                    sx={{
                                        border: '1px solid #333',
                                        fontWeight: 'bold',
                                        padding: '8px',
                                        fontSize: '14px'
                                    }}
                                >
                                    Date of Admission
                                </TableCell>
                                <TableCell sx={{ border: '1px solid #333', padding: '8px' }}>
                                    <CustomTextField
                                        type="date"
                                        value={studentData?.dateOfAdmission}
                                        variant="standard"
                                        fullWidth
                                        InputProps={{ disableUnderline: true }}
                                        sx={{ fontSize: '14px' }}
                                    />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
            {studentData?.appliedHostel && (
                <Paper
                    sx={{
                        border: '1px solid #333',
                        borderRadius: 1,
                        p: 2,
                        mb: 3
                    }}
                >
                    <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} gap={2}>
                        <Box flex={1}>
                            <Typography variant="h6" mb={2}>
                                Hostel Record
                            </Typography>

                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <LabelledField label="Hostel Name">
                                        <CustomTextField value={studentData?.hostelDetails?.hostelName} />
                                    </LabelledField>
                                </Grid>

                                <Grid item xs={12}>
                                    <LabelledField label="Room No.">
                                        <CustomTextField value={studentData?.hostelDetails?.roomNo} />
                                    </LabelledField>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <LabelledField label="Admission Fee Paid (Rs.)">
                                        <CustomTextField value={studentData?.hostelDetails?.admissionFee} />
                                    </LabelledField>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <LabelledField label="DD / Cash">
                                        <CustomTextField value={studentData?.hostelDetails?.paymentMode} />
                                    </LabelledField>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <LabelledField label="Payment Date">
                                        <CustomTextField type="date" value={studentData?.hostelDetails?.paymentDate} />
                                    </LabelledField>
                                </Grid>
                            </Grid>

                            <Box display="flex" justifyContent="space-between" mt={4} color="#c13a3a">
                                <div>Date.............</div>
                                <div>Hostel Incharge</div>
                            </Box>
                            <Box mt={4}>
                                <Typography mb={1}>ADMITTED to............................</Typography>
                                <Typography mb={1}>Class Roll No............................</Typography>
                            </Box>
                            <Box display="flex" justifyContent="space-between" mt={4} color="#c13a3a">
                                <div>Dated...............</div>
                                <div>Registrar</div>
                            </Box>
                        </Box>

                        <Box
                            sx={{
                                width: '1px',
                                backgroundColor: '#000',
                                display: { xs: 'none', md: 'block' }
                            }}
                        />

                        <Box flex={1}>
                            <Typography mb={2}>
                                Certificates/ Document and their attested copies are attached with Admission Form
                            </Typography>

                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <LabelledField label="Permanent Address of the Student">
                                        <CustomTextField multiline rows={4} value={studentData?.permanentAddress} />
                                    </LabelledField>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <LabelledField label="Pin">
                                        <CustomTextField value={studentData?.pinCode} />
                                    </LabelledField>
                                </Grid>
                            </Grid>

                            <Box display="flex" justifyContent="space-between" mt={4} color="#c13a3a">
                                <div>Dated.....................</div>
                                <div>Verifying Officer</div>
                            </Box>

                            <Box mt={4}>
                                <Typography>Received Students Conduct and Discipline Rules.</Typography>
                            </Box>

                            <Box display="flex" justifyContent="space-between" mt={4} color="#c13a3a">
                                <div>Dated.................</div>
                                <div>Signature of the Student</div>
                            </Box>
                        </Box>
                    </Box>
                </Paper>
            )}
        </div>
    );
};

export default AdmissionCard;
